export default "__VITE_ASSET__$O3QNurk__"